// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_t3-0";